import { client as axios } from "./axiosClient";
import { Constants, catchServiceException } from "@socialcoach/services";
import * as DTO from "../interfaces/dtos";

const ASSISTANTS_SERVICE = `${Constants.API_URL}/assistants`;
export class AssistantServices {
  @catchServiceException()
  static async getByCoachId(coachId: string): Promise<DTO.Assistant[]> {
    const response = await axios.get<DTO.Assistant[]>(`${ASSISTANTS_SERVICE}/coach/${coachId}`, {
      withCredentials: true,
    });

    return response.data;
  }

  static async getInactive(coachId: string): Promise<DTO.Assistant[]> {
    const response = await axios.get<DTO.Assistant[]>(`${ASSISTANTS_SERVICE}/coach/${coachId}?status=SUSPENDED`, {
      withCredentials: true,
    });
    return response.data;
  }

  @catchServiceException()
  static async getPending(coachId: string): Promise<DTO.Assistant[]> {
    const response = await axios.get<DTO.Assistant[]>(`${ASSISTANTS_SERVICE}/coach/${coachId}?status=PENDING`, {
      withCredentials: true,
    });
    return response.data;
  }

  static async get(assistantId: string): Promise<DTO.Assistant> {
    const response = await axios.get<DTO.Assistant>(`${ASSISTANTS_SERVICE}/${assistantId}`, { withCredentials: true });
    return response.data;
  }

  @catchServiceException()
  static async createAssistant(coachId: number, payload: DTO.CreateAssistantRequest): Promise<DTO.Assistant> {
    const response = await axios.post<DTO.Assistant>(`${ASSISTANTS_SERVICE}/coach/${coachId}`, payload, {
      withCredentials: true,
    });
    return response.data;
  }

  @catchServiceException()
  static async updateAssistant(assistantId: number, payload: DTO.UpdateAssistantRequest): Promise<DTO.Assistant> {
    const response = await axios.post<DTO.Assistant>(
      `${ASSISTANTS_SERVICE}/${assistantId}`,
      { ...payload },
      { withCredentials: true }
    );
    return response.data;
  }
}
